import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    CreateScheduledClassParams,
    failureCreateScheduledClass,
    successCreateScheduledClass,
} from "./CreateScheduledClassSlice";

// API call to create or update a scheduled class
const CreateScheduledClassApi = (params: CreateScheduledClassParams) => {
    const formData = new FormData();
    const classData = { ...params.class_data };

    // 1. Append worksheet files separately if provided
    if (params.worksheets && Array.isArray(params.worksheets)) {
        params.worksheets.forEach((file: File) => {
            formData.append('worksheets', file);
        });
        // Remove files from class_data to avoid serialization issues
        if (classData.worksheets && Array.isArray(classData.worksheets)) {
            classData.worksheets = classData.worksheets.filter((item: number | File) => typeof item === 'number');
            if (classData.worksheets.length === 0) delete classData.worksheets;
        }
    }

    // 2. Append sample booklet files separately if provided
    if (params.sample_booklet_files && Array.isArray(params.sample_booklet_files)) {
        params.sample_booklet_files.forEach((file: File) => {
            formData.append('sample_booklets', file);
        });
        // Remove files from class_data to avoid serialization issues
        if (classData.sample_booklets && Array.isArray(classData.sample_booklets)) {
            classData.sample_booklets = classData.sample_booklets.filter((item: number | File) => typeof item === 'number');
            if (classData.sample_booklets.length === 0) delete classData.sample_booklets;
        }
    }

    // 3. Append the class_data as JSON
    formData.append('class_data', JSON.stringify(classData));

    return api.post('/api/schedule-class/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Saga to handle creating/updating scheduled class
export function* CreateScheduledClassCall(action: PayloadAction<CreateScheduledClassParams>) {
    try {
        const response: AxiosResponse = yield call(CreateScheduledClassApi, action.payload);
        yield put(successCreateScheduledClass(response.data));
    } catch (error: any) {
        yield put(failureCreateScheduledClass(error.response?.data || error.message));
    }
}
